  import { useContext } from "react";
import { SocketContext } from "../context/SocketProvider";
import { useRoleBackground } from "../hooks/useRoleBackground";
import { useLanguage } from "../context/LanguageContext";
import default1 from "../assets/step1_default.png";
import disabled1 from "../assets/step1_disabled.png";
import default2 from "../assets/step2_default.png";
import disabled2 from "../assets/step2_disabled.png";
import default3 from "../assets/step3_default.png";
import disabled3 from "../assets/step3_disabled.png";
import wordsDefault1 from "../assets/step1_words_default.png";
import wordsDisabled1 from "../assets/step1_words_disabled.png";
import { FaChevronRight } from "react-icons/fa6"; 
import { SlArrowLeft } from "react-icons/sl";

/**
 * HowToPlay component displays the instructions for the game in a step-by-step format.
 */
const HowToPlay = ({
  onNext,
  onPrev,
  onSkip,
  step = 1,
  gamemode = "normal",
}) => {
  const { role } = useContext(SocketContext);
  const color = role === "describer" ? "pink" : "blue";
  const { className, bgStyle } = useRoleBackground(color);
  const { t, language } = useLanguage();

  return (
    <div
      className={`flex flex-col justify-center items-center ${className}`}
      style={bgStyle}
    >
      <div className="mt-[4px] my-[70px] w-[1052px] h-[600px] bg-white rounded-lg shadow-lg flex flex-col items-center text-center">
        <h2
          className={`bg-${color}400 w-full rounded-t-lg font-bold text-white text-xl font-[22px] py-[16px] px-[12px]`}
        >
          {t("howToPlay.title", "HOW TO PLAY:")}
        </h2>
        <div className="flex-1 flex flex-col justify-between w-full">
          <div className="px-[25px] py-[48px] grid grid-cols-3 gap-[24px] rounded-lg place-items-center h-[354px] w-[1052px]">
          {/* Card 1 */}
          <div className="flex flex-col items-center w-full rounded-xl">
            <div className="mb-[17px] w-full"></div>
            <div>
              <img
                src={
                  gamemode === "normal"
                    ? step === 1
                      ? default1
                      : disabled1
                    : step === 1
                    ? wordsDefault1
                    : wordsDisabled1
                }
                alt="graphic icon"
                className="w-[318px] h-[258px] object-cover rounded"
              />
            </div>
          </div>

          {/* Card 2*/}
          <div className="flex flex-col items-center w-full rounded-xl">
            <div className="mb-[17px] w-full"></div>
            <div>
              <img
                src={step === 2 ? default2 : disabled2}
                alt="graphic icon"
                className="w-[318px] h-[258px] object-cover rounded"
              />
            </div>
          </div>
          {/* Card 3 */}
          <div className="flex flex-col items-center w-full rounded-xl">
            <div className="mb-[17px] w-full"></div>
            <div>
              <img
                src={step === 3 ? default3 : disabled3}
                alt="graphic icon"
                className="w-[318px] h-[258px] object-cover rounded"
              />
            </div>
          </div>
          </div>
          <div className="flex flex-col justify-between flex-1">
            <div>
              <p className="w-full px-[72px] text-[20px]">
                {step === 1 ? (
                  gamemode === "wordsChallenge" ? (
                    <>
                      {t(
                        "howToPlay.step1WordsDescriptionPart1",
                        "The Describer gets an image and a list of words. They write a description so"
                      )}{" "}
                      <span className="font-bold">
                        {t(
                          "howToPlay.step1WordsDescriptionPart2",
                          "the Guesser can understand"
                        )}
                      </span>{" "}
                      {language === "en" && "but"}
                      <span className="font-bold">
                        {t("howToPlay.step1WordsDescriptionPart3", "AICOM-chan can't.")}
                        
                      </span>
                      <br />
                      {t(
                        "howToPlay.step1WordsDescriptionPart5",
                        "For every word from the list used in the description, the Players gets 2 extra points."
                      )}
                    </>
                  ) : (
                    <>
                      {t(
                        "howToPlay.step1DescriptionPart1",
                        "First, the Describer has 2 minutes to choose an image and write a description they think"
                      )}
                      <span className="font-bold">
                        {t(
                          "howToPlay.step1DescriptionPart2",
                          "the Guesser can understand"
                        )}
                      </span>
                      {language === "en"}
                      
                      {t("howToPlay.step1DescriptionPart6", "but")}
                      <span className="font-bold">
                        
                        {t("howToPlay.step1DescriptionPart4", `AICOM-chan can't.`)}      
                      </span>
                      
                      {t("howToPlay.step1DescriptionPart5", "")}
                    </>
                  )
                ) : step === 2 ? (
                  <>
                    {t(
                      "howToPlay.step2DescriptionPart1",
                      "Then,"
                    )}{" "}
                    <span className="font-bold">
                      {t(
                        "howToPlay.step2DescriptionPart2",
                        " without communicating with the Describer,"
                      )}
                      </span>
                      <span>
                      {t(
                        "howToPlay.step2DescriptionPart3",
                        ", the Guesser reads the description and has 1 minute to"
                      )}
                    </span>
                    <span className="font-bold">
                      {t(
                        "howToPlay.step2DescriptionPart4",
                        ", select the image they think best fits the description."
                      )}
                    </span>
                  </>
                ) : (
                  <>
                    {t(
                      "howToPlay.step3DescriptionPart1",
                      "Finally, AICOM-chan will select the image they think best fits, and then the results are revealed! If the"
                    )}
                    <span className="font-bold">
                     {
                     t(
                       "howToPlay.step3DescriptionPart2",
                       "Guesser guessed correctly"
                     )}
                   </span>        
                   <span>
                     {
                     t(
                       "howToPlay.step3DescriptionPart3",
                       "and"
                     )}
                   </span>  
                   <span className="font-bold">
                     {
                     t(
                       "howToPlay.step3DescriptionPart4",
                       "AICOM-chan was wrong,"
                     )}
                   </span>  
                   <span>
                     {
                     t(
                       "howToPlay.step3DescriptionPart5",
                       " then the Players win! Points are rewarded or deducted based off of how well you did."
                     )}
                   </span>          
                  </>
                )}
              </p>
            </div>
            <div className="flex gap-[24px] mb-[24px] ml-[548px]">
          <button
            className={`${
              color === "blue"
                ? "btn-blue-sm-transparent"
                : "btn-pink-sm-transparent"
            } relative`}
            onClick={onSkip}
          >
            <span className="btn-text-pos-right-sm">
              {t("button.skip", "Skip")}{" "}
            </span>
            <FaChevronRight className="arrow-pos-right-sm" />
          </button>
          <button
            className={`${
              color === "blue" ? "btn-blue-sm" : "btn-pink-sm"
            } relative`}
            onClick={onPrev}
            disabled={step === 1}
          >
            <span className="btn-text-pos-left-sm">
              {t("button.previous", "Previous")}{" "}
            </span>
            <SlArrowLeft className="arrow-pos-left-sm" />
          </button>
          <button
            className={`${
              color === "blue" ? "btn-blue-sm" : "btn-pink-sm"
            } relative`}
            onClick={step < 3 ? onNext : onSkip}
          >
            {step === 3 ? (
              <span className="btn-text-pos-right-sm">
                {t("button.start", "Start!")}{" "}
              </span>
            ) : (
              <span className="btn-text-pos-right-sm">
                {t("button.next", "Next")}{" "}
              </span>
            )}

            <FaChevronRight className="arrow-pos-right-sm" />
          </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToPlay;
